export enum WoundsRadioGroupId {
  GROUP_ID_ADMITTED_INJURED = 703536
}

export enum WoundsRadioGroupExpressions {
  EXPRESSION_ADMITTED_INJURED = 'admittedInjury',
}

export enum WoundsOptionsId {
  SECTOR            = 'N',
  HOSPITAL_CLINIC   = 'S',
  COMMUNITY         = 'C',
}

export enum AdmittedInjuriesRadioGroup {
  SECTOR            = 0,
  HOSPITAL_CLINIC   = 1,
  COMMUNITY         = 2
}
